import React from "react";

import Navbar from "../components/Navbar";
import PriceAndTiqBanner from "../components/PricingAndTiqBanner";
import Policy from "../components/Policy";
import Calltoaction from "../components/Calltoaction";
import Footer from "../components/Footer";

export default function PolicyPage() {
  return (
    <>
      <Navbar />
      <PriceAndTiqBanner />
      <Policy />
      <Calltoaction />
      <Footer />
    </>
  );
}
